export type RemConfig = {
    /**
     * 设计稿宽度(px)
     */
    designWidth: number;
    /**
     * rem 基准值(px)，需要与 postcss-pxtorem 的 rootValue 保持一致
     */
    base: number;
    /**
     * 限制参与计算的最小宽度(px)，避免极小屏过度缩小
     */
    minWidth: number;
    /**
     * 限制参与计算的最大宽度(px)，避免平板/PC 过度放大
     */
    maxWidth: number;
};

const DEFAULT_CONFIG: RemConfig = {
    designWidth: 375,
    base: 12,
    minWidth: 320,
    maxWidth: 540,
};

let currentConfig: RemConfig = { ...DEFAULT_CONFIG };

function clamp(value: number, min: number, max: number) {
    return Math.min(Math.max(value, min), max);
}

export function applyRem() {
    const w = clamp(document.documentElement.clientWidth, currentConfig.minWidth, currentConfig.maxWidth);
    document.documentElement.style.fontSize = `${(w / currentConfig.designWidth) * currentConfig.base}px`;
}

export function setRemConfig(config?: Partial<RemConfig> | null) {
    currentConfig = { ...DEFAULT_CONFIG, ...(config ?? {}) };
    applyRem();
}

export function getRemConfig(): RemConfig {
    return { ...currentConfig };
}

let isInited = false;
export function initRem(config?: Partial<RemConfig> | null) {
    if (config) setRemConfig(config);
    else applyRem();

    if (isInited) return;
    isInited = true;
    window.addEventListener("resize", applyRem);
    window.addEventListener("orientationchange", applyRem);
}

// 默认初始化（全局 import 时生效）
initRem();
